enum AppScreen {
    SURVEY_SELECTOR = 'SURVEY_SELECTOR',
    GEOGRAPHY_SELECTOR = 'GEOGRAPHY_SELECTOR',
    TABLE_SELECTOR = 'TABLE_SELECTOR',
}

export default AppScreen;
